import React, { useEffect, useState } from 'react'
import { LeftSide, RightSide, SectionName, SubHeaderContainer, ButtonCreate, TabsDiv, Tab } from '../../../components/styles/subheader-style'
import { Content } from './style'
import { GlobalTable, Th, HeaderLine, Tr, Td } from '../../../components/styles/table-style'
import axios from '../../../config/axios'
import { Outlet, useNavigate, useOutletContext, useLocation } from 'react-router-dom'
import { TypeMainOutlet } from '..'
import stock from '../../../assets/stock/TableMovementHeader/list-active.svg'
import resource from '../../../assets/home/resource.svg'
import steel from '../../../assets/home/steel.svg'

export interface Resources {
  tabIndex: number
  setTabIndex: React.Dispatch<React.SetStateAction<number>>
}

const tabs = [
  { path: '/panel/stock', image: stock, name: 'Matéria prima' },
  { path: '', image: resource, name: 'Insumos' },
  { path: '/panel/product-final', image: steel, name: 'Produto engenheirado' }
]


const ResourcesSubHeader: React.FC<{ tabIndexActived: number }> = ({
  tabIndexActived }) => {

  const navigate = useNavigate()
  const [tabIndex, setTabIndex] = useState<number>(0)

  const handleCreateClick = () => {
    navigate('create')
  }

  return (
    <>
      <SubHeaderContainer>
        <LeftSide>
          <SectionName>Estoque</SectionName>
          <TabsDiv>
            {tabs.map((tab, index) => (
              <Tab
                key={index}
                $isFirst={index === 0}
                $isLast={index === tabs.length - 1}
                $isActive={index === tabIndexActived}
                onClick={() => {
                  if (index !== tabIndexActived) {
                    if (index === 0) {
                      navigate('/panel/stock');
                    } else if (index === 1) {
                      navigate('/panel/resource');
                    } else if (index === 2) {
                      navigate('/panel/product-final');
                    }
                  }
                }}
              >
                <img src={tab.image} alt={`${tab.path}-icon`} />
                {tab.name}
              </Tab>
            ))}
          </TabsDiv>
        </LeftSide>
        <RightSide>
          <ButtonCreate onClick={handleCreateClick}>+ Adicionar Insumo</ButtonCreate>
        </RightSide>
      </SubHeaderContainer>
    </>
  )
}

const getActiveIndex = (pathname: string) => {
  if (pathname.includes('/panel/resource')) return 1;
  if (pathname.includes('/panel/product-final')) return 2;
  if (pathname.includes('/panel/stock')) return 0;
  return 0;
};

const ResourcesContent = () => {
  const location = useLocation(); 
  const [tabIndex, setTabIndex] = useState<number>(getActiveIndex(location.pathname));
  const context = useOutletContext<TypeMainOutlet>();

  const search = context?.search || '';
  return (
    <>
      <ResourcesSubHeader tabIndexActived={getActiveIndex(location.pathname)} />
      <Content>
        <Outlet context={{ search }} />
      </Content>
    </>
  )
}

export default ResourcesContent
